import React, { useState } from 'react';
import { Box, BoxProps, Stack, Heading, HeadingProps } from '@hover/blueprint';
import { ButtonProps } from '@hover/blueprint/brand';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';

interface Props extends BoxProps {
  image: React.ReactNode;
  body: string;
  headingColor: HeadingProps['color'];
  bodyColor?: HeadingProps['color'];
  buttonProps?: ButtonProps;
}

const ReadyToSeeWithImage: React.FC<Props> = ({
  image,
  headingColor,
  body,
  buttonProps,
  bodyColor,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => setIsOpen(!isOpen);
  return (
    <Box w="100%" justifyContent="center" {...rest} py={1000}>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Stack
        maxW="1290px"
        w="100%"
        spacing={{ base: 700, desktop: '60px' }}
        direction={{ base: 'column', desktop: 'row' }}
        px={{ base: 500, tablet: '56px' }}
        alignItems="center"
      >
        <Box minW={{ base: 'auto', tablet: '454px' }} maxW="454px">
          {image}
        </Box>
        <Box
          w="100%"
          flexDir="column"
          justifyContent="center"
          alignItems={{ base: 'center', desktop: 'flex-start' }}
        >
          <Heading
            as="h2"
            color={headingColor}
            textAlign={{ base: 'center', desktop: 'left' }}
            marginBottom={{ base: 500, tablet: 500, desktop: 500 }}
            size={{ base: 500, tablet: 600, desktop: 700 }}
          >
            Ready to see the possibilities?
          </Heading>
          <Heading
            as="p"
            color={bodyColor}
            isDisplay
            textAlign={{ base: 'center', desktop: 'left' }}
            marginBottom={{ base: 700, tablet: 700 }}
            size={{ base: 300, tablet: 500 }}
          >
            {body}
          </Heading>
          <ArrowButton
            onClick={toggleModal}
            w={{ base: '100%', tablet: '196px' }}
            {...buttonProps}
          >
            GET STARTED
          </ArrowButton>
        </Box>
      </Stack>
    </Box>
  );
};

ReadyToSeeWithImage.defaultProps = {
  bodyColor: 'neutral.900',
};

export default ReadyToSeeWithImage;
